<template>
  <div class="recharge_left capital_first">
    <div class="perfect_content">
      <div class="content_title">{{$t('pc.myaccount.my_cash_coupons')}}</div>
      <div class="content_table">
        <ul class="list" v-for="item in list">
          <li>
            <div style="padding-left: 10px">
              <span>{{$t('pc.usercoupon.cash_coupon')}}: {{$t('pc.capital.recharge_full')}}{{item.amount * 10}}{{$t('pc.usercoupon.get_rmb')}}{{item.amount}}{{$t('pc.home.USD')}}</span><br>
              <div style="display: flex; width: 100%">
                <div style="float: left;width: 50%">
                <span >{{$t('pc.capital.recharge_validity')}}: {{$getDeviceTime(item.effect_date)}}</span></div> <div style="text-align: right;width: 50%;padding-right: 20px">
                <router-link to="/myaccount/capital" v-if="item.status === 0" style="background-color: red;color: white;padding: 5px 15px 5px 15px;border-radius: 25px;">{{item.statustext}}</router-link>
                <button v-if="item.status === 1" style="background-color: white;color: red;border: 1px solid red;padding: 5px 15px 5px 15px;border-radius: 25px;outline: none;">{{item.statustext}}</button></div>
              </div>
              <span>{{$t('pc.usercoupon.requirements')}}: {{$t('pc.usercoupon.after_margin_financing_purchase_amount_reaches')}}{{(item.amount  + (item.amount  * 10))*10}}{{$t('pc.usercoupon.withdrawal_is_available_after_rmb')}}</span><br>
            </div>
          </li>
        </ul>
        <div v-if="list.length == 0" style="text-align:center">
            {{$t('pc.usercoupon.no_records_yet')}}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import $ from "jquery";
import utils from "../assets/js/utils";
export default {
  name: "usercoupon",
  data() {
    return {
      list: [], //真实姓名

    };
  },
  mounted: function() {
    this.realNameConfig();
  },
  methods: {

    realNameConfig() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "my_coupon",
            token: sessionStorage.getItem("token"),
          }
        })
        .then(function(res) {
          if (res.data.code === 1) {
            that.list = res.data.data;
          } else {
            // that.isFirstTimeTrading = true;
            // localStorage.setItem("isFirstTimeRecharge", true);
          }
        });
    },
  }
};
</script>
<style scoped>
.perfect_left {
  width: 1000px;
  float: right;
  text-align: center;
}
.perfect_title {
  width: 100%;
  height: 30px;
  text-align: left;
  margin: 56px 0 30px 0;
  border-bottom: 1px solid #2b7ea8;
}
.perfect_title div {
  width: 100px;
  font-size: 14px;
  line-height: 14px;
  color: #2f7ca8;
  padding-bottom: 15px;
  border-bottom: 3px solid #2f7ca8;
  margin-left: 10px;
  text-align: center;
}
.perfect_content {
  width: 1000px;
  margin: 20px auto 0;
  border: 1px solid #eee;
}
.content_title {
  height: 80px;
  line-height: 100px;
  font-size: 20px;
  text-align: left;
  margin-left: 20px;
}
.content_table {
  margin-bottom: 40px;
}
.content_table table {
  width: 924px;
  margin: 0 auto;
  height: 310px;
  margin-bottom: 40px;
  border: 1px solid #ccc;
}
.content_table table tr td:nth-child(1) {
  width: 240px;
  height: 55px;
  text-align: left;
  color: #666;
  background-color: #f3f3f3;
  border-bottom: 1px solid white;
}
.content_table table tr td:nth-child(1) img {
  vertical-align: bottom;
  margin-left: 50px;
}
.content_table table tr td:nth-child(2) {
  width: 648px;
  height: 55px;
  overflow: hidden;
  background-color: white;
  border-bottom: 1px solid #ccc;
}
.content_table table tr td:nth-child(2) div:nth-child(1) select {
  height: 30px;
}
.content_table table tr td:nth-child(2) div:nth-child(1) {
  float: left;
  color: #101010;
  /* font-weight: 600; */
  margin-left: 40px;
  font-size: 14px;
}
.content_table
table
tr
td:nth-child(2)
div[data-v-7b54854c]:nth-child(1)
> span {
  display: inline-block;
  margin-right: 5px;
}
.content_table table tr td:nth-child(2) div:nth-child(2) {
  float: right;
  color: #62a1d6;
  border-bottom: 1px solid #62a1d6;
  margin-right: 60px;
  cursor: pointer;
  font-size: 14px;
}
.content_table table tr #change {
  border-bottom: 0;
}
/*弹窗1*/
.modify1,
.modify2,
.modify3,
.modify4,
.modify5 {
  width: 480px;
  height: 245px;
  border-radius: 10px;
  background-color: white;
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  margin: auto;
  border: 1px solid #000;
}
.modify11 {
  height: 3q10px;
}
.modify2 {
  height: 285px;
}
.modify3 {
  height: 285px;
}
.modify4 {
  height: 355px;
}
.modify5 {
  height: 415px;
}
.modify_title {
  width: 400px;
  margin: 0 auto;
  overflow: hidden;
  height: 80px;
  line-height: 100px;
  font-size: 20px;
}
.modify_title div:nth-child(1) {
  float: left;
  color: #5c5992;
  font-weight: 600;
}
.modify_title div:nth-child(2) {
  float: right;
  font-size: 30px;
  cursor: pointer;
}
.modify1_content {
  width: 400px;
  margin: 0 auto;
}
.modify1_content input {
  width: 85%;
  height: 40px;
}
.choice_bank {
  outline: none;
  border: none;
  font-size: 14px;
  line-height: 40px;
  width: 356px;
  display: inline-block;
  height: 40px;
  background: transparent;
}
.choice_bank > option {
  display: inline-block;
  font-size: 14px;
  line-height: 40px;
  height: 40px;
}
.modify_foot button {
  position: absolute;
  bottom: 20px;
  left: 0;
  right: 0;
  display: inline-block;
  width: 200px;
  margin: 0 auto;
  height: 45px;
  font-size: 16px;
}
.instead {
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  display: none;
  background-color: rgba(0, 0, 0, 0.6);
}
/*弹窗2*/

.modify2_content {
  width: 400px;
  margin: 0 auto;
}
.modify2_content div:nth-child(1) {
  margin-bottom: 40px;
}
.modify3_content div:nth-child(1),
.modify3_content div:nth-child(4) {
  width: 400px;
  height: 40px;
  line-height: 40px;
  margin: 0 auto 20px;
  border: 1px solid #ddd;
}
.modify3_content div:nth-child(1) span,
.modify3_content div:nth-child(4) span {
  font-size: 20px;
  margin-left: 15px;
}
.modify3_content div:nth-child(1) input,
.modify3_content div:nth-child(4) input {
  width: 80%;
  height: 30px;
  line-height: 45px;
  /*border: 1px solid #000;*/
}
.code1,
.code2 {
  width: 400px;
  position: relative;
  overflow: hidden;
  margin: 20px auto;
}
.code1 span,
.code2 span {
  width: 10%;
  font-size: 20px;
  position: absolute;
  left: 15px;
  top: 10px;
  vertical-align: middle;
}
.code1 input,
.code2 input {
  height: 40px;
  line-height: 40px;
  width: 58%;
  border: 1px solid #ddd;
  padding-left: 40px;
  float: left;
  /*margin-left: 8px;*/
}
.code1 img,
.code2 button {
  float: left;
  margin-left: 10px;
}
.code2 button {
  width: 28%;
  height: 40px;
  color: white;
  background-color: #566b96;
}
.getPass {
  margin: 20px auto;
  display: block;
}
.select-class {
  margin: 20px auto;
  display: block;
  width: 400px;
  font-size: 14px;
  padding: 0 15px;
  border: 1px solid #dcdfe6;
  height: 40px;
  line-height: 40px;
  border-radius: 4px;
}
.modifybox {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.5);
  display: none;
  z-index: 9;
}
/* 绑定手机号 */
.modify-codebox {
  display: felx;
  justify-content: space-around;
  width: 400px;
  margin: 20px auto;
}
.modify-code {
  width: 283px;
}
</style>

<style>
#firstTimeRechargePopup .el-form-item{
  margin-bottom: 11px;
}
#firstTimeRechargePopup .el-dialog__body {
  padding: 0px;
}
#firstTimeRechargePopup .el-form-item__content {
  margin-left: 0px !important;
}
#firstTimeRechargePopup .el-dialog {
  width: 25%;
  margin-top: 17% !important;
}

.list {
  display: inline-block;
  padding-left: 15px;
  padding-right: 15px;
  width: 100%;
  margin: 0;
}

.list > li {
  width: 100%;
  border: 1px solid lightgrey;
  box-sizing: border-box;
  font-size: 14px;
  line-height: 30px;
  padding: 0;
  /*text-indent: 56px;*/
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/components/usercoupon.vue